import { Card, CardContent, CardHeader, Divider, Grid } from "@mui/material";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MapitPhoneInput, MapItTextField } from "src/components/common";

export default function ContactDetails({
    contact,
    validationErrors,
    handleChange,
    CardTitle = "Contact Info"
}) {
    const { t } = useTranslation();
    return (
        <Card>
            <CardHeader title={t(CardTitle)} />
            <Divider />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <MapItTextField
                            label={t("Name")}
                            size="small"
                            name="name"
                            value={get(contact, "name") || ""}
                            required
                            handleChange={handleChange}
                            error={get(validationErrors, "name")}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MapitPhoneInput
                            label={t("Phone")}
                            name="phone"
                            value={get(contact, "phone")}
                            handleChange={handleChange}
                            error={get(validationErrors, "phone")}
                            required
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}